var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m899.63 699.1 156.98 95.859c29.438 17.953 49.031 48.422 53.109 82.688 4.0781 34.219-7.8281 68.484-32.203 92.859-30.516 30.516-65.625 65.625-92.297 91.969-35.859 35.859-87.422 51.141-137.02 40.594l-0.09375-0.046875c-426.79-91.969-683.16-349.22-770.76-770.39v-0.14062c-10.078-49.359 5.2969-100.5 40.922-136.08l92.625-92.578c24.328-24.375 58.594-36.234 92.812-32.156 34.266 4.0781 64.734 23.672 82.734 53.062l95.812 156.98c27.094 44.344 20.297 101.44-16.453 138.19-10.359 10.312-21.281 21.234-30.656 31.078-0.1875 0.1875-0.375 0.42188-0.60938 0.65625-9.375 9.375-13.078 23.062-9.6094 35.906 37.688 138.56 127.64 227.68 268.87 268.5 13.125 3.7031 27.188 0 36.797-9.6094l30.891-30.891c36.703-36.703 93.797-43.5 138.14-16.453z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3e0137ec1f3d9597d4f0ac72381016e5.svg";
export { ForwardRef as ReactComponent };